<template>
    <div v-show="isActive" class="row text-center mt-5">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <img :src="$window.enforceCDN('/tabselev/img/vipps-logo-orange.png')" alt="Vipps logo" width="180" class="mx-auto">
                    <p class="mb-0"><small v-show="orderId !== null">Ordre ID: {{ orderId }}</small></p>
                    <p class="mb-0"><small v-show="rawAmount !== 0">Beløp: {{ amount }} kr</small></p>
                    <p class="fw-bold" :class="titleClasses" v-show="title">{{ title }}</p>
                    <p>{{ description }}</p>

                    <div class="text-center" v-show="inProgress">
                        <span class="spinner-border" role="status"></span>
                    </div>
                    <div class="text-center" v-show="displayTryAgainButton">
                        <button class="btn btn-success" @click="tryAgain"><strong><i class="fas fa-redo mr-2"></i> Prøv igjen</strong></button>
                    </div>
                    <div class="text-center" v-show="displayGoToAccountButton">
                        <a class="btn btn-secondary px-3" href="/account"><strong>Til kontooversikt</strong></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import Store from '../../state/vippsStore'
import { toMoney } from '../../lib/format'

const props = defineProps(['inprogress'])

const isActive = computed(() => Store.getIsActive())
const orderId = computed(() => Store.getOrderId())
const amount = computed(() => toMoney(Store.getAmount()))
const rawAmount = computed(() => Store.getAmount())
const inProgress = computed(() => Store.getInProgress())
const title = computed(() => Store.getTitle())
const displayTryAgainButton = computed(() => Store.getTryAgainButton())
const displayGoToAccountButton = computed(() => Store.getGoToAccountButton())
const titleClasses = computed(() => {
    const cssClasses = {}
    cssClasses[Store.getTitleClass()] = true
    return cssClasses
})
const description = computed(() => Store.getDescription())

const tryAgain = () => {
    window.location.href = '/payment?metode=vipps'
}

onMounted(() => {
    console.log(props.inprogress)
    if (props.inprogress == 1) {
        Store.setIsActive(true)
        Store.setInProgress(true)
        Store.checkPaymentStatus()
    }
})
</script>
